
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recurring",
      function () {
        return require("private-next-pages/recurring.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recurring"])
      });
    }
  